import React from 'react';
import ProjectCard from '../components/ProjectCard';

const Projects = () => {
    const projects = [
        {
            title: 'Generative AI Theatrical Immersive Experience',
            description: 'An innovative application leveraging generative AI to create immersive theatrical experiences.',
            link: 'https://linkedin.com/in/jerome-ronquillo-mse-4063bb76/'
        },
        {
            title: 'Full Stack development integrating Unity and Drupal',
            description: 'A full-stack application integrating Unity for 3D graphics and Drupal for content management.',
            link: 'https://linkedin.com/in/jerome-ronquillo-mse-4063bb76/'
        },
        {
            title: 'Election App',
            description: 'Application that spanned different tech stacks and industries, showcasing versatility and adaptability.',
            link: 'https://linkedin.com/in/jerome-ronquillo-mse-4063bb76/'
        }
    ];

    return (
        <div className="projects-page">
            <h1 className="prompt-bold white-text">My Projects</h1>
            <div className="projects-list">
                {projects.map((project, index) => (
                    <ProjectCard 
                        key={index} 
                        title={project.title} 
                        description={project.description} 
                        link={project.link} 
                    />
                ))}
            </div>
        </div>
    );
};

export default Projects;